import * as React from 'react';
import { useMemo } from 'react';
import { Omit } from 'react-redux';
import Progress from 'src/components/Progress';
import { IProgressProps } from 'src/components/Progress';
import { useSelector } from 'src/utils';

export type IIndicatorProps = Omit<IProgressProps, 'open'>;

const Indicator: React.FC<IIndicatorProps> = props => {
	const keys = useSelector(state => state.indicator.keys);
	const open = useMemo(() => Object.values(keys).some(x => x), [keys]);

	return <Progress {...props} open={open} />;
};

export default Indicator;



// WEBPACK FOOTER //
// ./src/containers/Indicator.tsx